import { siteStats } from "@/mocks/site";

export default function StatsBar() {
  return (
    <section className="w-full bg-background-100 border-b border-background-200">
      <div className="max-w-content mx-auto px-4 md:px-8 py-8 md:py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {siteStats.map((stat, index) => (
            <div
              key={stat.label}
              className={`flex items-start gap-4 ${
                index !== siteStats.length - 1 ? "lg:border-r lg:border-background-300/70" : ""
              }`}
            >
              <span className="w-11 h-11 shrink-0 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${stat.icon} text-xl`}></i>
              </span>
              <span>
                <span className="block font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  {stat.value}
                </span>
                <span className="block mt-0.5 text-sm text-foreground-700">{stat.label}</span>
                <span className="block text-xs text-foreground-400">{stat.sub}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}